import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function AboutUs() {
  const points = [
    "Jangkauan luas hingga ke pelosok nusantara",
    "Sistem pelacakan real-time 24/7",
    "Armada terawat dan berstandar tinggi",
    "Tim profesional dan berpengalaman"
  ];

  return (
    <section id="tentang" className="py-24 bg-light overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-orange/20 rounded-[2rem] transform -rotate-3 scale-105 -z-10"></div>
            <img
              src="/images/about-us.jpg"
              alt="Tentang Garuda Ekspress"
              className="rounded-[2rem] shadow-xl object-cover w-full h-[400px] lg:h-[500px]"
            />


          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-6">Membawa Amanah Anda Hingga ke Tujuan</h2>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              Didirikan dengan visi untuk memajukan sistem logistik di Indonesia, <strong>Garuda Ekspress Logistik</strong> hadir sebagai solusi pengiriman barang yang cepat, aman, dan dapat diandalkan.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Kami memahami bahwa setiap paket memiliki nilai dan urgensi tersendiri. Oleh karena itu, kami terus berinovasi dan memperluas jaringan untuk memastikan layanan kelas satu bagi pelanggan personal maupun korporasi.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {points.map((point, index) => (
                <div key={index} className="flex items-center gap-3">
                  <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-orange flex-shrink-0" />
                  <span className="text-navy font-medium">{point}</span>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}